import React, { useEffect, useState } from 'react';
import './index.css';
import SearchInput from 'common/components/SearchInput';

//import filter, sort, export and plus
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import { ReactComponent as SortIcon } from 'common/icons/sort.svg';
import { ReactComponent as ExportIcon } from 'common/icons/export.svg';
import { ReactComponent as ImportIcon } from 'common/icons/import.svg';
import { ReactComponent as PrintIcon } from 'common/icons/printer.svg';
import { ReactComponent as PlusIcon } from 'common/icons/plus.svg';
import IconButton from 'common/components/IconButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CustomTable from './components/CustomTable';
import sendFetch from 'common/utils/fetch';
import { useAuth } from 'common/context/AuthContext';
import ButtonDropdownMenuProps from 'common/types/ButtonDropdownMenuProps';
import MenuIconButton from 'common/components/MenuIconButton';
import { TableNavButton } from 'common/styles/TableNavButton';
import OrderDataTableProps from 'common/types/OrderDataTableProps';
import StatusEnum from 'common/types/StatusEnum';
import statusList from 'common/data/statusList';
import OrderColumns from 'common/types/OrderColumns';
import ServicesComp from 'pages/ServicesPage/components/Services';

type TypeProps = 'orders' | 'services' | 'logistics' | 'warehouse' | 'marketing' | 'finance' | 'reports' | 'workspace' | string | null;

// For Order Card
// const testData: OrderDataTableProps[] = [
//   {
//     id: 123,
//     clientForOrder: {
//       firstName: 'Василь',
//       lastName: 'Пупкін',
//       patronymic: 'Петрович',
//       phoneNumber: '+380123456789',
//     },
//     acceptedDate: '2021-09-01',
//     issueDate: '2021-09-01',
//     factDate: '2021-09-01',
//     isGetInfoOnEmail: true,
//     isGetInfoAboutReady: false,
//     isGetReceiptOnEmail: true,
//     recepient: {
//       firstName: 'Іван',
//       lastName: 'Іванов',
//       patronymic: 'Іванович',
//     },
//     employeeFirstName: 'Алексій',
//     employeeLastName: 'Іванов',
//     employeePatronymicName: 'Александрович',
//     statusOrder: StatusEnum.received,
//     priceList: 'EKO Odesa',
//     serviceItem: [
//       {
//         id: '1',
//         name: 'Послуга 1',
//         price: 100,
//       },
//     ],
//   },
// ];

const testData: OrderDataTableProps[] = [
  {
    id: 123,
    clientName: 'Іванов І.І.',
    employeeName: 'Пупкін В.В.',
    acceptanceDate: '2021-09-01T00:00:00',
    issueDate: '2021-09-01T00:00:00',
    factIssueDate: '2021-09-01T00:00:00',
    priceList: 'EKO Odesa',
    pickUpDepartment: 'Відділення №1',
    isPartner: true,
    price: 100,
    orderStatus: StatusEnum.received,
  },
];

function convertToColumnData(data: OrderDataTableProps[]): OrderColumns[] {
  const columns: OrderColumns[] = [];


  // convert dates from yy
  
  data.map((el) => {
    let status = statusList.find((statusEl) => statusEl.value === 2);
    if (el.orderStatus > 0) {
      status = statusList.find((statusEl) => statusEl.value === el.orderStatus);
    }
    if (el.clientName?.split(' ').length > 1) {
      const name = el.clientName?.split(' ');
      el.clientName = `${name[1]} ${name[0][0]}.${ name[2] ? name[2][0] + '.' : ''}`;
    }
    
    columns.push({
      id: el.id,
      name: el.clientName,
      clientPhone: el.clientPhone,
      clientEmail: el.clientEmail,
      status: status?.label,
      statusColor: status?.color,
      isPartner: el.isPartner,
      priceList: el.priceList,
      acceptanceDate: el.acceptanceDate,
      issueDate: el.issueDate,
      factDate: el.factIssueDate,
      executor: el.employeeName,
      location: el.pickUpDepartment,
      price: typeof(el.price) === 'number' ? el.price?.toFixed(2) : el.price,
    });
  });
  console.log(data[0]);
  console.log(columns);
  return columns;
}

const useSort = ({ data, config }: { data: OrderColumns[]; config: { key: string; direction: string } }) => {
  const [sortConfig, setSortConfig] = useState(config);
  const [sortedData, setSortedData] = useState<OrderColumns[]>([]);
  useEffect(() => {
    console.log('sort');
    const sortableData = [...data];
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    setSortedData(sortableData);
  }, [data, sortConfig]);
  const requestSort = (key: string) => {
    let direction = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  return { data: sortedData, requestSort, sortConfig };
};


export default function ServicesPage() {
  const { companyId } = useAuth();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('search') || '';
  const type: TypeProps = searchParams.get('type') || '';

  const [searchValue, setSearchValue] = useState(search);
  const [tableLoading, setTableLoading] = useState(false);
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);
  const [isPrintMenuOpen, setIsPrintMenuOpen] = useState(false);
  const [isImportMenuOpen, setIsImportMenuOpen] = useState(false);
  const [tableData, setTableData] = useState<OrderColumns[]>([]);

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  type ResponseProps = {
    status?: string;
    statusCode: number | string;
    orderList?: OrderDataTableProps[];
  };

  useEffect(() => {
    const fetchTableData = async () => {
      setTableLoading(true);
      const link = 'https://api-workspace.astin.net/api/order/get-order-list';
      const formData = new FormData();
      formData.append('companyId', companyId);
      const response: [number, ResponseProps] = await sendFetch(link, {
        method: 'POST',
        data: formData,
      });
      console.log(response);
      if (response[0] === 200 && response[1].statusCode === 200) {
        setTableLoading(false);
        setTableData(convertToColumnData(response[1].orderList.reverse()) || []);
      } else {
        setTableLoading(false);
      }
    };
    if (companyId) {
      fetchTableData();
    }
  }, [companyId]);

  const handleTypeChange = (value: string | null) => {
    if (value) {
      searchParams.set('type', value);
    } else {
      searchParams.delete('type');
    }
    setSearchParams(searchParams, { replace: true });
  };

  const handleSearchSubmit = (value: string) => {
    if (value) {
      searchParams.set('search', value);
    } else {
      searchParams.delete('search');
    }
    setSearchParams(searchParams, { replace: true });
  };

  const ExportButtonMenu: ButtonDropdownMenuProps[] = [
    {
      label: 'Microsoft Excel (.xlsx)',
      onClick: () => { },
    },
    {
      label: 'OpenDocument (.ods)',
      onClick: () => { },
    },
    {
      label: 'PDF (.pdf)',
      onClick: () => { },
    },
    {
      label: 'Веб-сторінка (.html)',
      onClick: () => { },
    },
    {
      label: 'Формат CSV (.csv)',
      onClick: () => { },
    },
    {
      label: 'Формат TSV (.tsv)',
      onClick: () => { },
    },
  ];


  const closeAllMenus = () => {
    setIsExportMenuOpen(false);
    setIsImportMenuOpen(false);
    setIsPrintMenuOpen(false);
  };

  const handleExportClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    closeAllMenus();
    setIsExportMenuOpen(!isExportMenuOpen);
  };
  const handlePrintClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    closeAllMenus();
    setIsPrintMenuOpen(!isPrintMenuOpen);
  };
  const handleImportClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    closeAllMenus();
    setIsImportMenuOpen(!isImportMenuOpen);
  };

  

  // close everything on clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.dropdown-menu')) {
        closeAllMenus();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  const isOrders = type !== 'services' && type !== 'logistics' && type !== 'warehouse' && type !== 'marketing' && type !== 'finance' && type !== 'reports' && type !== 'workspace';

  const { data:sortedTableData, requestSort, sortConfig } = useSort({
    data: tableData,
    config: { key: 'acceptanceDate', direction: 'descending' },
  });
  console.log(requestSort);
  console.log(sortConfig);
  const fakeClient = { city: 'od', country: 'uk',
    firstName: 'Kons', id: '2f57861b-1936-473f-f46b-08dc1a8decdd', lastName: 'Vahrushev', patronymic: 'u', phoneNumber: '011' };
  const fakefirm = '45d29e94-09bb-4b5a-acf9-dff2c5b9ff47';
  const fakeorderId = 8580989;
  const fakepriceList = '978d097b-f2c1-42fa-a3b8-c88b594a40c9';

  return (
    <section className="contacts-section">
      <h2 className='new-h2'>Операції</h2>
      <div style={{ marginTop: '24px' }} className='table-navigation-wrapper'>
        <TableNavButton onClick={() => { handleTypeChange('orders'); }} className={isOrders && 'active'}>Замовлення</TableNavButton>
        <TableNavButton onClick={() => { handleTypeChange('services'); }} className={type === 'services' && 'active'}>Послуги</TableNavButton>
        <TableNavButton onClick={() => { handleTypeChange('logistics'); }} className={type === 'logistics' && 'active'}>Логістика</TableNavButton>
        <TableNavButton onClick={() => { handleTypeChange('warehouse'); }} className={type === 'warehouse' && 'active'}>Склад</TableNavButton>
        <TableNavButton onClick={() => { handleTypeChange('marketing'); }} className={type === 'marketing' && 'active'}>Маркетинг</TableNavButton>
        <TableNavButton onClick={() => { handleTypeChange('finance'); }} className={type === 'finance' && 'active'}>Фінанси</TableNavButton>
        <TableNavButton onClick={() => { handleTypeChange('reports'); }} className={type === 'reports' && 'active'}>Звіти</TableNavButton>
        <TableNavButton onClick={() => { handleTypeChange('workspace'); }} className={type === 'workspace' && 'active'}>Робочий простір</TableNavButton>
      </div>
      {/* temporary component for demo */}
      {type === 'services' &&
        <ServicesComp client={fakeClient} orderId={fakeorderId} itemCount={3}
                      firm={fakefirm} selectedItem={null} priceList={fakepriceList} setStage={()=>{}} setSelectedItem={()=>{}} setPageType={()=>{}} />
      }
      {isOrders &&
        <>
          <div className='contacts-menu-line'>
            <div className='contacts-menu-wrapper'>
              <SearchInput value={searchValue} onChange={handleSearchChange} searchFunction={handleSearchSubmit} />
              <IconButton label='Фільтри'>
                <FilterIcon className='svg-black' />
              </IconButton>
              <IconButton label='Сортування'>
                <SortIcon className='svg-black' />
              </IconButton>
            </div>
            <div className='contacts-menu-wrapper'>
              <IconButton label='Створити замовлення' onClick={() => {
                navigate({ pathname: 'orders/create' });
              }}>
                <PlusIcon className='svg-black' />
              </IconButton>
              <MenuIconButton position='left' label='Експортувати' isOpen={isExportMenuOpen} onClick={handleExportClick}
                              menuData={ExportButtonMenu}>
                <ExportIcon className='svg-black' />
              </MenuIconButton>
              <MenuIconButton position='left' label='Імпортувати' isOpen={isImportMenuOpen} onClick={handleImportClick}
                              menuData={ExportButtonMenu}>
                <ImportIcon className='svg-black' />
              </MenuIconButton>
              <MenuIconButton position='left' label='Друкувати' isOpen={isPrintMenuOpen} onClick={handlePrintClick}
                              menuData={ExportButtonMenu}>
                <PrintIcon className='svg-black' />
              </MenuIconButton>
            </div>
          </div>
          <CustomTable loading={tableLoading}
                       data={tableData.length === 0 ? convertToColumnData(testData) : sortedTableData}
                       searchValue={search} />
        </>
      }
    </section>
  );
}